import React, { useState } from "react";
import { Box, Card, Typography, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ProgramList from "../../../../Components/Programs/new";
import ProgramAttendence from "../../../../Components/Attendence/new";

const useStyles = makeStyles(() => ({
    // categoryContainer: {
    //     display: "flex",
    //     flexDirection: "column",
    //     borderRadius: "12px",
    //     height: '100vh', // Full height to keep it static
    //    
    //     width: '100%',
    //     position: 'sticky',
    //     top: 0,
    //     padding: 16,
    // },
    categoryCard: {
        cursor: "pointer",
        textAlign: "left",
        borderRadius: "12px !important",
        height: "auto",
        boxShadow: "none !important",
        fontWeight: 500,
        fontSize: "16px",
        marginBottom: "20px",
    },
    selectedCategory: {
        border: "2px solid #016AA7",
    },
}));

const MyPath: React.FC = () => {
    const classes = useStyles();
    const [selectedCategory, setSelectedCategory] = useState("Attendance");

    return (

        <Grid container sx={{ height: '33vh !important' }}>
            <Grid item xs={3} sx={{ backgroundColor: "#F6F8FB", height: 'calc(46vh) !important', borderRadius: 2, padding: 2 }}>
                <Box >
                    <Typography sx={{ fontWeight: 500, fontSize: "16px", marginBottom: "20px", textAlign: 'left', color: '#373A45' }}>
                        Categories
                    </Typography>
                </Box>
                <Card
                    sx={{
                        cursor: "pointer",
                        textAlign: "left",
                        borderRadius: "12px !important",
                        boxShadow: "none !important",
                        marginBottom: "16px",
                        border: selectedCategory === "Attendance" ? "1px solid #016AA7" : "2px solid transparent",
                    }}
                    onClick={() => setSelectedCategory("Attendance")}
                >
                    <Typography className="p-3" sx={{fontSize:'14px',fontWeight:500}}>Attendance</Typography>
                </Card>


                <Card
                    sx={{
                        cursor: "pointer",
                        textAlign: "left",
                        borderRadius: "12px !important",
                        boxShadow: "none !important",
                        marginBottom: "20px",
                        border: selectedCategory === "Programs" ? "1px solid #016AA7" : "2px solid transparent",
                    }}
                    onClick={() => setSelectedCategory("Programs")}
                >
                    <Typography className="p-3" sx={{fontSize:'14px',fontWeight:500}}>Programs</Typography>
                </Card>


            </Grid>

            {/* Content Section */}
            <Grid item xs={9} >
                {selectedCategory === "Attendance" && <ProgramAttendence />}
                {selectedCategory === "Programs" && <ProgramList />}
            </Grid>
        </Grid>
    );
};

export default MyPath;
